import gql from 'graphql-tag';

export default gql`
fragment AdminCmsAllData on AdminCmsContent {
    id
    title
    content
    url_key
    is_active
    active_from
    active_to
    meta_title
    meta_keywords
    meta_description
    created_at
    updated_at
}
`;


// WEBPACK FOOTER //
// ./src/api/graphql/fragments/AdminCmsAllData.ts